import { render } from "./DashboardView.vue?vue&type=template&id=914ae610&scoped=true&ts=true"
import script from "./DashboardView.vue?vue&type=script&lang=ts"
export * from "./DashboardView.vue?vue&type=script&lang=ts"

import "./DashboardView.vue?vue&type=style&index=0&id=914ae610&scoped=true&lang=scss"

import exportComponent from "E:\\Documents\\Development\\juwie-giveaway\\juwie-giveaway-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-914ae610"]])

export default __exports__